module.exports = __webpack_public_path__ + "img/d97d9694f1fc279726a1bce5dabf07b-1.dd533d9a.jpg";